<template>
    <el-container direction="vertical" class="production-list">
        <el-row class="header">
            <div>
                <el-col :span="20" class="title">
                    {{ title }}
                </el-col>
                <el-col :span="3">
                    <el-button class="spreadsheet-header-button" type="warning" @click="goNewProductionExpense" v-if="headerOptions.isNewButtonVisible && canCreateExpense">
                        новый расход
                    </el-button>
                </el-col>
            </div>
        </el-row>
        <el-row class="main" v-loading="loading">
            <el-col>
                <div v-for="position in expenses" :key="position.factory.id">
                    <div class="row" @click="handlePositionClick(position)">
                        <div :class="['name', { 'icon-noactive': !position.expenses }]">
                            <i class="el-icon-caret-bottom" v-if="position.isOpened"></i>
                            <i class="el-icon-caret-right" v-else></i>
                            {{ position.factory.name }}:
                        </div>
                    </div>
                    <template v-if="position.isOpened">
                        <div v-for="expenseByDate in position.expenses" :key="expenseByDate.date">
                            <div class="row" @click="handleExpenseByDateClick(expenseByDate)">
                                <div class="name pl15">
                                    <i class="el-icon-caret-bottom" v-if="expenseByDate.isOpened"></i>
                                    <i class="el-icon-caret-right" v-else></i>
                                    {{ expenseByDate.date }}
                                </div>
                            </div>
                            <div class="grid-wrapper">
                                <expense-production-deals-grid
                                    :expenses="expenseByDate.data"
                                    v-if="expenseByDate.isOpened"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/expenses-production-list.scss?1';
import localReferences from '@/helpers/localReferences';
import ExpenseProductionDealsGrid from '@/components/expenses/ExpenseProductionDealsGrid';

export default {
    name: 'ProductionExpenses',
    components: { ExpenseProductionDealsGrid },
    data() {
        return {
            localReferences,
            title: 'Расходы производству',
            pageName: 'expenses-production',
            loading: false,
            expenses: [],
            totalDebtsAmount: null,
            isOpened: false,
            headerOptions: {
                isNewButtonVisible: true
            }
        };
    },
    beforeMount() {
        this.getProductionExpensesAll();
    },
    mounted() {
        this.$store.commit('expenses/setCurrentPage', this.pageName);
    },
    computed: {
        canCreateExpense() {
            return this.$store.getters.isExpensesAll;
        }
    },
    methods: {
        goNewProductionExpense() {
            this.$router.push({ name: 'production-expense-card', params: { id: 'new' } });
        },
        async getProductionExpensesAll() {
            await this.$store.dispatch('expenses/getProductionExpensesAll').then(
                response => {
                    this.expenses = response;
                },
                error => {
                    if (error.response.status === 403) {
                        console.log(error.response.data.error);
                    }
                }
            );
        },
        handlePositionClick(position) {
            position.isOpened = !position.isOpened;
        },
        handleExpenseByDateClick(position) {
            position.isOpened = !position.isOpened;
        }
    }
};
</script>
